module.exports = __webpack_public_path__ + "static/media/praia7.4f96717e.jpeg";